import Vue from 'vue'
import Router from 'vue-router'
import RealtyPage from '../components/realty/RealtyPage.vue'
import Insights from '../components/insights/Insights.vue'
import Entry from '../components/insights/Entry.vue'
// import TheMarketplace from '../components/marketplace/TheMarketplace.vue'
import ClaimSearch from '../components/claimSearch/ClaimSearch.vue'
import RealtorSignUp from '../components/realty/RealtorSignUp.vue'
import ServiceProviderSignUp from '../components/serviceprovider/ServiceProviderSignUp.vue'
import HomePage from '../components/home/HomePage.vue'
import SignIn from '../components/authentication/SignInPage.vue'
import PropertySearchBasePage from '../components/home/homeSearch/PropertySearchBasePage.vue'
import PropertySearch from '../components/home/homeData/PropertySearch.vue'
import PropertyCreationPage from '../components/home/homeData/PropertyCreationPage.vue'
import HomFAXReportMarketing from '../components/homfax/HomFAXReportMarketingPage.vue'
import UserPropertyPage from '../components/home/homeData/UserPropertyPage.vue'
import TheProfile from '../components/profile/TheProfile.vue'
import Dashboard from '../components/profile/businessProfile/dashboard/Dashboard.vue'
import Details from '../components/profile/businessProfile/details/Details.vue'
import Overview from '../components/profile/businessProfile/details/details/Overview.vue'
import Services from '../components/profile/businessProfile/details/details/Services.vue'
import About from '../components/profile/businessProfile/details/details/About.vue'
import Preferences from '../components/profile/businessProfile/details/details/Preferences.vue'
import HomaptContacts from '../components/profile/businessProfile/contacts/HomaptContacts.vue'
import HomaptAdvertising from '../components/profile/businessProfile/advertising/HomaptAdvertising.vue'
import Security from '../components/profile/shared/security/Security.vue'
import Pictures from '../components/profile/shared/pictures/Pictures.vue'
import TheForgotPassword from '../components/authentication/TheForgotPassword.vue'
import TheRoadmap from '../components/roadmap/TheRoadmap.vue'
import TheSaveTimeMoney from '../components/saveTimeMoney/TheSaveTimeMoney.vue'
import Rebates from '../components/realty/Rebates.vue'
import Business from '../components/business/Business.vue'
import BusinessProfile from '../components/profile/businessProfile/BusinessProfile.vue'
import UserProfile from '../components/profile/userProfile/UserProfile.vue'
import UserDashboard from '../components/profile/userProfile/profiles/UserDashboard.vue'
import UserDetails from '../components/profile/userProfile/profiles/UserDetails.vue'
import UserAlerts from '../components/profile/userProfile/profiles/UserAlerts.vue'
// import UserWallet from '../components/profile/userProfile/profiles/UserWallet.vue'
import UserProfiles from '../components/profile/userProfile/profiles/UserProfiles.vue'
import RealtorCheckout from '../components/profile/realtorProfile/RealtorCheckout.vue'
import RealtorDashboard from '../components/profile/realtorProfile/RealtorDashboard.vue'
import RealtorDetails from '../components/profile/realtorProfile/RealtorDetails.vue'
import RealtorPaymentInfo from '../components/profile/realtorProfile/RealtorPaymentInfo.vue'
import RealtorSubscriptions from '../components/profile/realtorProfile/RealtorSubscriptions.vue'
import RealtorSupport from '../components/profile/realtorProfile/RealtorSupport.vue'
import ServiceProviderCheckout from '../components/profile/serviceProviderProfile/ServiceProviderCheckout.vue'
import ServiceProviderDashboard from '../components/profile/serviceProviderProfile/ServiceProviderDashboard.vue'
import ServiceProviderDetails from '../components/profile/serviceProviderProfile/ServiceProviderDetails.vue'
import ServiceProviderSubscriptions from '../components/profile/serviceProviderProfile/ServiceProviderSubscriptions.vue'
import ServiceProviderPaymentInfo from '../components/profile/serviceProviderProfile/ServiceProviderPaymentInfo.vue'
import PriorityAdvertising from '../components/profile/businessProfile/advertising/priority/PriorityAdvertising.vue'
import PriorityOverview from '../components/profile/businessProfile/advertising/priority/subnavItems/Overview.vue'
import PriorityOrder from '../components/profile/businessProfile/advertising/priority/subnavItems/Order.vue'
import PrioritySpec from '../components/profile/businessProfile/advertising/priority/subnavItems/Specialties.vue'
import PriorityCheckout from '../components/profile/businessProfile/advertising/priority/subnavItems/Checkout.vue'
import CouponAdvertising from '../components/profile/businessProfile/advertising/coupons/CouponAdvertising.vue'
import CouponOverview from '../components/profile/businessProfile/advertising/coupons/subnavItems/Overview.vue'
import CouponDetails from '../components/profile/businessProfile/advertising/coupons/subnavItems/Details.vue'
import CouponMessages from '../components/profile/businessProfile/advertising/coupons/subnavItems/Messages.vue'
import CouponLegal from '../components/profile/businessProfile/advertising/coupons/subnavItems/Legal.vue'
import CouponCheckout from '../components/profile/businessProfile/advertising/coupons/subnavItems/Checkout.vue'
import Terms from '../components/legal/Terms.vue'
import Privacy from '../components/legal/Privacy.vue'
import ProfSupport from '../components/profsupport/TheProfSupport.vue'
import FAQ from '../components/faq/FAQ.vue'
import Messaging from '../components/profile/shared/messaging/Messaging.vue'
import ContactUs from '../components/contact/ContactUs.vue'
import { store } from '../store/store.js'

Vue.use(Router)

const businessOnlyPaths = [
  '/profile/business',
  '/profile/business/dashboard',
  '/profile/business/details',
  '/profile/business/details/overview',
  '/profile/business/details/services',
  '/profile/business/details/pictures',
  '/profile/business/details/about',
  '/profile/business/details/preferences',
  '/profile/business/contacts',
  '/profile/business/advertising',
  '/profile/business/advertising/priority',
  '/profile/business/advertising/priority/overview',
  '/profile/business/advertising/priority/order',
  '/profile/business/advertising/priority/specialties',
  '/profile/business/advertising/priority/checkout',
  '/profile/business/advertising/coupons',
  '/profile/business/advertising/coupons/overview',
  '/profile/business/advertising/coupons/details',
  '/profile/business/advertising/coupons/messages',
  '/profile/business/advertising/coupons/legal',
  '/profile/business/advertising/coupons/checkout',
  '/profile/business/security'
]

const userOnlyPaths = [
  '/profile/user',
  '/profile/user/dashboard',
  '/profile/user/details',
  '/profile/user/pictures',
  '/profile/user/alerts',
  '/profile/user/wallet',
  '/profile/user/profiles',
  '/profile/user/security'
]

const loginPaths = [
  '/messaging'
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: to => {
        const host = window.location.host
        const hostParts = host.split('.')
        if (hostParts[0] === 'realtor') {
          return '/signin'
        }
        return '/propertysearch'
      }
    },
    { path: '/faq', component: FAQ },
    { path: '/home', component: HomePage },
    { path: '/signin', component: SignIn },
    { path: '/propertysearch', component: PropertySearchBasePage },
    { path: '/propertysearch/:id/:searchString/:endPath', component: PropertySearch },
    { path: '/property/new', component: PropertyCreationPage },
    { path: '/property/:id', component: UserPropertyPage },
    { path: '/homfaxreport', component: HomFAXReportMarketing },
    { path: '/terms', component: Terms },
    { path: '/insights', component: Insights },
    { path: '/insights/:entry', component: Entry },
    { path: '/privacy', component: Privacy },
    { path: '/realty', component: RealtyPage },
    { path: '/contact', component: ContactUs }, /*
    { path: '/marketplace',
      component: TheMarketplace,
      props: (route) => ({
        query: route.query.q,
        place: route.query.p
      })
    }, */
    { path: '/claimsearch', component: ClaimSearch },
    { path: '/realtorsignup', component: RealtorSignUp },
    { path: '/serviceprovidersignup', component: ServiceProviderSignUp },
    { path: '/profsupport', component: ProfSupport },
    { path: '/messaging', component: Messaging },
    { path: '/profile',
      component: TheProfile,
      children: [
        {
          path: 'user',
          component: UserProfile,
          children: [
            { path: 'dashboard', component: UserDashboard },
            { path: 'details', component: UserDetails },
            { path: 'alerts', component: UserAlerts },
            { path: 'pictures', component: Pictures },
            // { path: 'wallet', component: UserWallet },
            { path: 'profiles', component: UserProfiles },
            { path: 'security', component: Security }
          ]
        },
        {
          path: 'realtor',
          component: UserProfile,
          children: [
            { path: 'checkout', component: RealtorCheckout },
            { path: 'dashboard', component: RealtorDashboard },
            { path: 'details', component: RealtorDetails },
            { path: 'paymentinfo', component: RealtorPaymentInfo },
            { path: 'subscriptions', component: RealtorSubscriptions },
            { path: 'support', component: RealtorSupport }
          ]
        },
        {
          path: 'serviceprovider',
          component: UserProfile,
          children: [
            { path: 'checkout', component: ServiceProviderCheckout },
            { path: 'dashboard', component: ServiceProviderDashboard },
            { path: 'details', component: ServiceProviderDetails },
            { path: 'paymentinfo', component: ServiceProviderPaymentInfo },
            { path: 'subscriptions', component: ServiceProviderSubscriptions },
            { path: 'support', component: RealtorSupport }
          ]
        },
        {
          path: 'business',
          component: BusinessProfile,
          children: [
            { path: 'dashboard', component: Dashboard },
            {
              path: 'details',
              component: Details,
              children: [
                { path: 'overview', component: Overview },
                { path: 'services', component: Services },
                { path: 'pictures', component: Pictures },
                { path: 'about', component: About },
                { path: 'preferences', component: Preferences }
              ]
            },
            { path: 'contacts', component: HomaptContacts },
            {
              path: 'advertising',
              component: HomaptAdvertising,
              children: [
                {
                  path: 'priority',
                  component: PriorityAdvertising,
                  children: [
                    { path: 'overview', component: PriorityOverview },
                    { path: 'order', component: PriorityOrder },
                    { path: 'specialties', component: PrioritySpec },
                    { path: 'checkout', component: PriorityCheckout }
                  ]
                },
                {
                  path: 'coupons',
                  component: CouponAdvertising,
                  children: [
                    { path: 'overview', component: CouponOverview },
                    { path: 'details', component: CouponDetails },
                    { path: 'messages', component: CouponMessages },
                    { path: 'legal', component: CouponLegal },
                    { path: 'checkout', component: CouponCheckout }
                  ]
                }
              ]
            },
            { path: 'security', component: Security }
          ]
        }
      ]
    },
    { path: '/forgotpassword', component: TheForgotPassword },
    { path: '/roadmap', component: TheRoadmap },
    { path: '/savetimemoney', component: TheSaveTimeMoney },
    { path: '/rebates', component: Rebates },
    { path: '/business/:id/:google/:center', component: Business }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  var userType = store.getters['user/getUserType']
  if (userType !== 'business') {
    if (businessOnlyPaths.includes(to.path)) {
      next(false)
    } else {
      next()
    }
  }

  if (userType === 'business') {
    // Block access to advertising screens based on information completion
    if (!store.getters['business/adminComplete'] &&
        ((to.path === '/profile/business/advertising/priority') ||
         (to.path === '/profile/business/advertising/priority/overview') ||
         (to.path === '/profile/business/advertising/priority/order') ||
         (to.path === '/profile/business/advertising/priority/checkout') ||
         (to.path === '/profile/business/advertising/coupons') ||
         (to.path === '/profile/business/advertising/coupons/overview') ||
         (to.path === '/profile/business/advertising/coupons/details') ||
         (to.path === '/profile/business/advertising/coupons/messages') ||
         (to.path === '/profile/business/advertising/coupons/legal') ||
         (to.path === '/profile/business/advertising/coupons/checkout')
        )
    ) {
      next(false)
    }
    // Block access to coupons if categories not specified
    if (!store.getters['business/getSelectedServices'].length &&
        ((to.path === '/profile/business/advertising/coupons') ||
         (to.path === '/profile/business/advertising/coupons/overview') ||
         (to.path === '/profile/business/advertising/coupons/details') ||
         (to.path === '/profile/business/advertising/coupons/messages') ||
         (to.path === '/profile/business/advertising/coupons/legal') ||
         (to.path === '/profile/business/advertising/coupons/checkout')
        )
    ) {
      next(false)
    }
    // Block access to messaging if coupon payment overdue
    if (store.getters['business/getCouponPaymentOverdue'] && (to.path === '/messaging')) {
      next(false)
    }
    if (userOnlyPaths.includes(to.path)) {
      next(false)
    } else if (to.path === '/claimsearch') {
      next(false)
    } else {
      next()
    }
  }

  // Block access to profile pages if unauthenticated user
  if (!store.getters['getIdProvider']) {
    if (userOnlyPaths.includes(to.path)) {
      next(false)
    } else if (businessOnlyPaths.includes(to.path)) {
      next(false)
    } else if (loginPaths.includes(to.path)) {
      next(false)
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js